


 import {Deserializable} from './deserializable.model';

export class SubjectComTypes {

    public subject_com_type_id?: number;
    public subject_com_type_name?: string;
    public brand_type_id?: number;
    public subject_com_type_description?: string;
    public is_active?: number;

    public send_to_invoice?: number;
    public send_to_report?: number;
    public send_to_logins?: number;

    public document_base_theme_docx;


  // ? what does this really do? (no encoding or deserialisation required...)
  deserialize(input: any): SubjectComTypes {
    Object.assign(this, input);

    return this;
  }


}

  // Set the Stats
